import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  IDeletePrefixServicesInt,
  IDeletePrefixServicesIntSuccessAction,
  DeletePrefixServicesErrorAction,
} from '../actions/delete-prefix-services-int'
import {IServicePerformanceState} from '../state'
import {initialState} from '../state/initial-state'

export type DeletePrefixServicesInt =
  | IDeletePrefixServicesInt
  | IDeletePrefixServicesIntSuccessAction
  | DeletePrefixServicesErrorAction

const init = (state: IServicePerformanceState, action: DeletePrefixServicesInt) => ({
  ...state,
  deletePrefixServicesInt: {
    ...state.deletePrefixServicesInt,
    status: action.status,
  },
})

const success = (state: IServicePerformanceState, action: DeletePrefixServicesInt) => ({
  ...state,
  deletePrefixServicesInt: {
    ...initialState.deletePrefixServicesInt,
    status: action.status,
    data: (action as IDeletePrefixServicesIntSuccessAction).data,
  },
})

const failure = (state: IServicePerformanceState, action: DeletePrefixServicesInt) => ({
  ...state,
  deletePrefixServicesInt: {
    ...initialState.deletePrefixServicesInt,
    status: action.status,
    error: (action as DeletePrefixServicesErrorAction).error,
  },
})

export const deletePrefixServicesReducerInt = createAsyncReducer(
  initialState,
  init,
  success,
  failure,
)
